<template lang="pug">
div(class="tw-flex")
  v-container(pa-0 class="tw-w-64 tw-mb-4")
    v-row(dense)
      v-col(class=" tw-rounded tw-overflow-hidden tw-py-2 tw-h-auto" @clic="open")
        div(class=" tw-bg-white tw-overflow-hidden tw-rounded-md tw-border tw-border-gray-lighten-2")
          v-row(no-gutters)
            v-col(pa-0)
              router-link(class="tw-font-medium text-link" :to="{ name: 'goodsItem', params: { id: item.id } }")
                v-img(
                  v-if="!item.galleries.length || !item.galleries[0].main_image"
                  :src="require('@/assets/images/placeholder-image.jpg')"
                  aspect-ratio="2"
                  fill
                )
                v-img(v-else :src="path(item.galleries[0].main_image.path)" aspect-ratio="2" fill)
          v-row(no-gutters class=" tw-p-0")
            v-col(shrink)
              v-row(no-gutters class="tw-border-b tw-border-t tw-border-blueGray-lighten-4")
                v-col(class="tw-m-3")
                  v-row(no-gutters)
                    v-col(cols="12")
                      div(class=" tw-font-bold tw-text-blueGray-darken-2 tw-text-lg")
                        router-link(class="tw-font-medium text-link" :to="{ name: 'goodsItem', params: { id: item.id } }") {{ item.name }}
                      div(class=" tw-pt-1 tw-font-medium tw-text-blueGray-darken-2 tw-text-base")
                        router-link(class="tw-font-medium text-link" :to="{ name: 'goodsItem', params: { id: item.id } }") {{ item.address_city }}, {{ item.address_zip_code }}
              v-row(no-gutters justify="space-around" class=" tw-px-2")
                v-col(cols="auto" class=" tw-items-center ")
                  v-row(no-gutters justify="center" class="tw-py-2")
                    v-col(v-if="item.bedrooms" class="tw-mr-2")
                      v-row(no-gutters align="center" justify="center")
                        v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                          span {{ item.bedrooms }}
                        v-col(cols="auto" class=" tw-text-center")
                          v-icon mdi-bed
                      v-row(no-gutters)
                        v-col(cols="auto" class=" tw-text-center tw-text-xs tw-capitalize")
                          | {{ $t('Listings.Common.bedrooms') }}
                    v-col(v-if="item.bathrooms" class="tw-mr-2")
                      v-row(no-gutters align="center" justify="center")
                        v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                          span {{ item.bathrooms }}
                        v-col(cols="auto" class=" tw-text-center")
                          v-icon mdi-shower
                      v-row(no-gutters)
                        v-col(class=" tw-text-center tw-text-xs tw-capitalize")
                          | {{ $t('Listings.Common.bathrooms') }}
              v-row(no-gutters justify="space-between" align="center" class=" tw-bg-blueGray-lighten-5 tw-p-3")
                v-col(cols="auto")
                  span(class="tw-text-xl tw-font-bold tw-text-blueGray-darken-2 tw-capitalize")
                    template(v-if="item.rent_enabled && item.sale_enabled")
                      span {{ $t('Listings.Common.rent') }} / {{ $t('Listings.Common.sale') }}
                    template(v-else)
                      span(v-if="item.rent_enabled") {{ $t('Listings.Common.rent') }}
                      span(v-if="item.sale_enabled") {{ $t('Listings.Common.sale') }}
                v-col(cols="auto" class=" tw-text-right  " align-self="center")
                  div(class=" tw-bg-white tw-border-blueGray-lighten-4 tw-border tw-rounded-full tw-p-2")
                    span(class="tw-font-extrabold tw-text-lg tw-text-blueGray-darken-2") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    open(item) {
      this.$router.push({ name: 'goodsItem', params: { id: this.$faker().datatype.number() } });
    },
  },
};
</script>
